var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5167 16.625L10.5292 11.6375C10.1333 11.9542 9.67813 12.2049 9.16354 12.3896C8.64896 12.5743 8.10139 12.6667 7.52083 12.6667C6.08264 12.6667 4.86545 12.1686 3.86927 11.1724C2.87309 10.1762 2.375 8.95903 2.375 7.52083C2.375 6.08264 2.87309 4.86545 3.86927 3.86927C4.86545 2.87309 6.08264 2.375 7.52083 2.375C8.95903 2.375 10.1762 2.87309 11.1724 3.86927C12.1686 4.86545 12.6667 6.08264 12.6667 7.52083C12.6667 8.10139 12.5743 8.64896 12.3896 9.16354C12.2049 9.67813 11.9542 10.1333 11.6375 10.5292L16.625 15.5167L15.5167 16.625ZM7.52083 11.0833C8.51042 11.0833 9.35156 10.737 10.0443 10.0443C10.737 9.35156 11.0833 8.51042 11.0833 7.52083C11.0833 6.53125 10.737 5.6901 10.0443 4.9974C9.35156 4.30469 8.51042 3.95833 7.52083 3.95833C6.53125 3.95833 5.6901 4.30469 4.9974 4.9974C4.30469 5.6901 3.95833 6.53125 3.95833 7.52083C3.95833 8.51042 4.30469 9.35156 4.9974 10.0443C5.6901 10.737 6.53125 11.0833 7.52083 11.0833Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.02a64cd464d0f245bc4c08e0660a6fa8.svg";
export { ForwardRef as ReactComponent };